import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import {  returnCategorySubCategory,subCategory,subject,returnSubCategory } from '../../models/walai';
declare var $: any;
@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.css']
})
export class SubcategoryComponent implements OnInit {
  returnCategorySubCategory:returnCategorySubCategory;
  subCategorys:subCategory[];

  returnSubCategory:returnSubCategory;
 cursubCategory:subCategory;
 CATIMG:string ='';
 CATNAMETHAI:string='';
 CATNAMEENG:string='Loading...';
 DESCRIPTION:string='';

 CATEGRPNAMETHAI:string='';
  subjects:subject[];
  locationID: string;
  public cateid: string;
  constructor(private homeService: HomeService,
    private route: ActivatedRoute,
    ) { }

  ngOnInit(): void {
    this.locationID = localStorage.getItem('locationIDMain'); // location หลัก
    this.cateid = this.route.snapshot.queryParamMap.get('cateid');
    this.getSubCategory(this.cateid);
  }

  getSubCategory(id:string){
    this.homeService.getSubCatagory(id).subscribe((returnCategorySubCategory:returnCategorySubCategory) => {
    
      this.returnCategorySubCategory = returnCategorySubCategory;
      const img = new Image();
      img.src = this.returnCategorySubCategory.CATIMG;
      img.onerror = () => {
        this.CATIMG = ''; // Set a default image path
      };
      img.onload = () => {
        this.CATIMG = this.returnCategorySubCategory.CATIMG;
      };
      this.CATNAMETHAI= this.returnCategorySubCategory.CATNAMETHAI;
      this.CATNAMEENG= this.returnCategorySubCategory.CATNAMEENG;
      this.DESCRIPTION= this.returnCategorySubCategory.DESCRIPTION;
      this.subCategorys = returnCategorySubCategory.subCategory;
      this.subCategorys.forEach((element) => {
        const _desc = element.CATEGRPDESC.replace(/<[^>]*>/g, '').replace(/View all/g, '').replace('...', '');

        const parser = new DOMParser();
        const doc = parser.parseFromString(element.CATEGRPDESC, 'text/html');
        const links = doc.querySelectorAll('a');
        links.forEach((link, index) => {
          element.CATEGRPDESCFull = _desc + link.getAttribute('title');
        });

        element.CATEGRPDESC = _desc;
      });
    });
  }

  getSubject(cat:subCategory){
    this.homeService.getSubject(cat.CATEGRPID).subscribe((cursubCategory:returnSubCategory) => {
      this.cursubCategory = cursubCategory.subCategory;
      this.CATEGRPNAMETHAI =   cat.CATEGRPNAMETHAI;
      this.subjects = cursubCategory.subjects;
      $('#subjectModal').modal('show');
    });
  }
  

}
